import styled from 'styled-components';
import MuiTableBody from '@mui/material/TableBody';

export const TableBody = styled(MuiTableBody)``;
